export default {
    add_patient: "Xəstə əlavə et",
    add_task: "Tapşırıq əlavə et",
    calls: "Zənglər",
    chat_panel: "Söhbət paneli",
    clinic_id: "Klinika ID",
    confirm: "Təsdiq edin",
    expenses: "Xərclər",
    high: "Yüksək",
    low: "Aşağı",
    medium: "Orta",
    no_notifications: "Bildiriş yoxdur",
    read_all: "Hamısını oxu",
    remove_confirmation: "Təsdiqi ləğv edin",
    tasks: "Tapşırıqlar"
}
